import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import FeatureSection from "@/components/FeatureSection";
import PartnersSection from "@/components/PartnersSection";
import CertificationsSection from "@/components/CertificationsSection";
import PortfolioSection from "@/components/PortfolioSection";
import GallerySection from "@/components/GallerySection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import SEOContent from "@/components/SEOContent";

function App() {
  useEffect(() => {
    // Initialize Lenis smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smooth: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#FAF8F5]">
      <SEOContent />
      <Navigation />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <FeatureSection />
      <PartnersSection />
      <CertificationsSection />
      <PortfolioSection />
      <GallerySection />
      <ContactSection />
      <Footer />
    </div>
  );
}

export default App;
